export function normalizeCpf(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, 11);
}

export function formatCpf(raw: string): string {
  const d = normalizeCpf(raw);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

/**
 * Validates the CPF check digits (algoritmo módulo 11).
 * Returns false for sequences of equal digits (e.g. 111.111.111-11) and any
 * CPF that fails the standard check-digit calculation.
 */
export function isValidCpf(raw: string): boolean {
  const cpf = normalizeCpf(raw);
  if (cpf.length !== 11) return false;
  if (/^(\d)\1+$/.test(cpf)) return false;

  const calcDigit = (slice: string): number => {
    const weightStart = slice.length + 1;
    const sum = slice
      .split("")
      .reduce((acc, n, i) => acc + parseInt(n, 10) * (weightStart - i), 0);
    const mod = (sum * 10) % 11;
    return mod === 10 ? 0 : mod;
  };

  const d1 = calcDigit(cpf.slice(0, 9));
  const d2 = calcDigit(cpf.slice(0, 9) + d1);
  return d1 === parseInt(cpf[9], 10) && d2 === parseInt(cpf[10], 10);
}
